import { PaymentPanel } from "../components/payment/PaymentPanel";
import { ErrorPanel, LoadingPanel } from "../components/StatePanels";
import { InvoiceContent } from "../features/invoices/InvoiceContent";
import { useAnonymousInvoicePage } from "./useAnonymousInvoicePage";

type Props = {
  invoiceCode: string;
};

export function AnonymousInvoicePage({ invoiceCode }: Props) {
  const page = useAnonymousInvoicePage(invoiceCode);

  if (page.status === "loading") return <LoadingPanel title="Loading invoice" />;

  if (page.status === "notFound")
    return (
      <ErrorPanel
        title="Invoice not found"
        message={page.message}
        action={{ href: page.returnRoute, label: "Back to search" }}
      />
    );

  if (page.status === "error")
    return <ErrorPanel title="Unable to load invoice" message={page.message} />;

  return (
    <InvoiceContent page={page}>
      {page.viewModel.paymentRail.canPay && (
        <PaymentPanel
          resource={{
            scope: { type: "invoice", invoiceCode: page.invoiceCode },
            ...page.viewModel.paymentPanel,
          }}
        />
      )}
    </InvoiceContent>
  );
}
